import classnames from 'classnames';
import React, { useRef, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { OptionLooks } from '../../../../enums/option.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import { baseListItemStyle } from '../../../../styles/styled-components/listitem.js';
import { mediaPrefersReducedMotion } from '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import { getOptionTheme } from '../../../../styles/styled-components/option.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import { truncateText } from '../../../../styles/styled-components/text.js';
import '../../../../styles/styled-components/tooltip.js';
import { BaseOption } from '../base-option/base-option.js';

const BaseStandardOption = (props)=>{
    const { className, ellipsis, index, listboxPadding, listboxRef, look, onClick, onSelected, option, selectedIndex, ...otherProps } = props;
    const { children, disabled, key, label, placeholder } = option;
    const selected = index === selectedIndex;
    const ref = useRef(null);
    useEffect(()=>{
        if (listboxRef && listboxRef.current && ref.current && selected) {
            const offsetHeight = listboxRef.current.offsetHeight;
            const offsetHeightHalf = Math.ceil(offsetHeight / 2);
            const offsetTop = ref.current.offsetTop;
            const offset = offsetTop - offsetHeightHalf;
            const top = listboxPadding ? offset + listboxPadding * 2 : offset;
            /**
       * If you change `scroll` `behavior`, also change `scrollToIndex` `behavior` in `StandardListbox`
       */ listboxRef.current.scroll({
                behavior: 'auto',
                top
            });
        }
    }, [
        selected
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React.createElement(BaseOption, {
        ...otherProps,
        className: classnames({
            'bf-option__standard': true,
            'bf-option__standard--ellipsis': ellipsis,
            'bf-option__standard--disabled': disabled,
            [`bf-option__standard--look-${look}`]: look,
            'bf-option__standard--placeholder': !!placeholder,
            'bf-option__standard--selected': selected,
            [`${className}`]: !!className
        }),
        disabled: disabled,
        id: key.toString(),
        label: label,
        onClick: disabled ? undefined : (e)=>{
            onSelected(index);
            if (onClick) {
                onClick(e);
            }
        },
        ref: ref,
        selected: selected
    }, index === 0 && placeholder || children);
};
const Option = styled(BaseStandardOption)`
  ${baseListItemStyle}
  cursor: pointer;
  display: block;
  padding: 10px;
  ${mediaPrefersReducedMotion}
  ${({ look })=>getOptionTheme({
        look
    })}
  ${({ ellipsis })=>ellipsis ? truncateText() : ''}

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;
/**
 * The `role="option"` is used to identify selections a user can make within a `role="listbox"`.
 *
 * Selected options have `aria-selected="true"`. Disabled options have `aria-selected="false"`
 * and `aria-disabled="true"`.
 *
 * https://www.w3.org/TR/wai-aria-1.2/#option
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/option_role
 *
 * @param props StandardOptionProps
 * @returns FunctionComponent<StandardOptionProps>
 */ const StandardOption = (props)=>{
    const { look = OptionLooks.Default, ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Option, {
        ...otherProps,
        look: look
    }));
};

export { BaseStandardOption, StandardOption };
//# sourceMappingURL=standard-option.js.map
